import { FC, lazy, Suspense, ComponentProps } from 'react';

const PdpSharedFreeShippingPillLazyComponent = lazy(
    () => import(/* webpackChunkName: "PdpSharedShippingBadge" */ './PdpSharedFreeShippingPill')
);

export const PdpSharedFreeShippingPillLazy: FC<
    ComponentProps<typeof PdpSharedFreeShippingPillLazyComponent>
> = props => (
    <Suspense fallback="">
        <PdpSharedFreeShippingPillLazyComponent {...props} />
    </Suspense>
);
